import { formatterMonthDate } from 'src/utils/formatDate'

const formatNumberBR = (num, digit = 0) =>
  new Intl.NumberFormat('pt-BR', {
    maximumFractionDigits: digit,
    minimumFractionDigits: digit
  }).format(num)

const unformatNumberBR = (strNum) => {
  if (strNum === '' || !strNum){
    return 0
  }

  return parseFloat(String(strNum).replace(/\./g, '').replace(/,/g, '.'))
}

const NumberFmt = ({ value, prefix = '', sufix = 'UN', digits = 0 }) => {
  if (typeof value !== 'number') {
    return value
  }

  return `${prefix}${formatNumberBR(value, sufix === 'KG' ? 3 : digits)} ${sufix}`.trim()
}

const useLast12Months = () => {
  const date = new Date()

  const dates = Array(12).fill(0).map(() => {
    date.setMonth(date.getMonth() - 1)
    return date.toISOString().slice(0, 7)
  })

  dates.unshift(new Date().toISOString().slice(0, 7))
  dates.pop()

  return dates.map((dateString, index) => ({
    Header: formatterMonthDate(dateString),
    id: dateString,
    accessor: dateString,
    width: 90,
    getProps: () => ({
      style: {
        textAlign: 'right',
      },
    }),
  }))
}

const weightFormatter = (value) => {
  if (!Number(value)) return ''

  const amount = new Intl.NumberFormat('pt-BR', {
    style: 'decimal',
    minimumFractionDigits: 3,
    maximumFractionDigits: 3
  }).format(value / 1000)

  return amount
}

const formatValueFromIsKg = (value, isKg) => {
  if (!Number(value)) return ''

  if(!isKg) return value.toString();
  const amount = weightFormatter(value)

  return amount

}

const measureUnit = (isKg) => isKg ? 'KG': 'UN'

export { formatNumberBR, unformatNumberBR, NumberFmt, useLast12Months, measureUnit, weightFormatter, formatValueFromIsKg }
